export const publicUrl = process.env.PUBLIC_URL;

export const facilities = [
  {
    id: 1,
    name: "Rooms",
    isRoomCategory: true,
    roomTypes: [
      {
        id: 1,
        name: "Luxury Room",
        price: 4000,
        description: "Experience unparalleled comfort in our elegantly designed luxury rooms, featuring modern amenities, plush bedding, and stunning views.",
        images: [
          `${publicUrl + "/static/images/room1.jpeg"}`,
          `${publicUrl + "/static/images/room2.jpeg"}`,
          `${publicUrl + "/static/images/room3.jpeg"}`,
          `${publicUrl + "/static/images/room4.JPG"}`

        ],
        features: ["King-size bed", "Private balcony", "Luxury bathroom", "Smart TV", "Room service"]
      },
      {
        id: 2,
        name: "Premium Room",
        price: 5000,
        description: "Indulge in ultimate luxury with our premium rooms, offering spacious layouts, premium furnishings, and exclusive amenities for a superior stay.",
        images: [
          `${publicUrl + "/static/images/room1.jpeg"}`,
          `${publicUrl + "/static/images/room2.jpeg"}`,
          `${publicUrl + "/static/images/room3.jpeg"}`,
          `${publicUrl + "/static/images/room4.JPG"}`
        ],
        features: ["King-size bed", "Private terrace", "Spa bathroom", "Smart home system", "Butler service"]
      }
    ]
  },
  {
    id: 2,
    name: "Swimming Pool",
    description: "Dive into relaxation at our pristine swimming pool with breathtaking views, surrounded by comfortable loungers and tropical ambiance.",
    image: [
      `${publicUrl + "/static/images/swimmingpool.jpeg"}`,
      `${publicUrl + "/static/images/swimmingpool2.jpeg"}`
    ],
    features: ["Infinity edge", "Heated water", "Pool bar", "Cabanas", "Sunset views"]
  },
  {
    id: 3,
    name: "Fine Dining Restaurant",
    isRestaurantCategory: true,
    restaurantTypes: [
      {
        id: 1,
        name: "Restaurant",
        description: "Savor exquisite culinary creations in our elegant indoor dining space, featuring award-winning chefs and a sophisticated ambiance.",
        images: [
          `${publicUrl + "/static/images/dining.jpg"}`
        ],
        features: ["Air-conditioned", "Wine cellar", "Private dining rooms", "Live music evenings", "Chef's table experience"]
      },
      {
        id: 2,
        name: "Garden Restaurant",
        description: "Dine under the stars in our beautiful garden restaurant, surrounded by lush greenery and the soothing sounds of nature.",
        images: [
          "https://images.unsplash.com/photo-1552566626-52f8b828add9",
          "https://images.unsplash.com/photo-1559339352-11d035aa65de",
          "https://images.unsplash.com/photo-1544148103-0773bf10d330"
        ],
        features: ["Open-air dining", "Garden views", "Natural ambiance", "Sunset dining", "BBQ specialties"]
      }
    ],
    hasMenu: true,
    menu: {
      categories: [
        {
          id: 1,
          name: "Starters",
          items: [
            {
              id: 1,
              name: "Grilled Prawns",
              description: "Succulent prawns marinated in herbs and spices, grilled to perfection",
              price: 850,
              vegetarian: false
            },
            {
              id: 2,
              name: "Paneer Tikka",
              description: "Cottage cheese cubes marinated in tandoori spices and grilled",
              price: 650,
              vegetarian: true
            },
            {
              id: 3,
              name: "Caesar Salad",
              description: "Fresh romaine lettuce with parmesan, croutons and Caesar dressing",
              price: 550,
              vegetarian: true
            }
          ]
        },
        {
          id: 2,
          name: "Main Course",
          items: [
            {
              id: 4,
              name: "Butter Chicken",
              description: "Tender chicken in rich tomato and butter gravy with aromatic spices",
              price: 1200,
              vegetarian: false
            },
            {
              id: 5,
              name: "Dal Makhani",
              description: "Black lentils slow-cooked with butter and cream",
              price: 750,
              vegetarian: true
            },
            {
              id: 6,
              name: "Grilled Fish",
              description: "Fresh catch of the day grilled with lemon butter sauce",
              price: 1400,
              vegetarian: false
            },
            {
              id: 7,
              name: "Vegetable Biryani",
              description: "Aromatic basmati rice cooked with mixed vegetables and spices",
              price: 950,
              vegetarian: true
            }
          ]
        },
        {
          id: 3,
          name: "Desserts",
          items: [
            {
              id: 8,
              name: "Gulab Jamun",
              description: "Traditional Indian sweet dumplings in sugar syrup",
              price: 350,
              vegetarian: true
            },
            {
              id: 9,
              name: "Chocolate Lava Cake",
              description: "Warm chocolate cake with a molten center, served with vanilla ice cream",
              price: 450,
              vegetarian: true
            },
            {
              id: 10,
              name: "Tiramisu",
              description: "Classic Italian dessert with coffee-soaked ladyfingers and mascarpone",
              price: 500,
              vegetarian: true
            }
          ]
        },
        {
          id: 4,
          name: "Beverages",
          items: [
            {
              id: 11,
              name: "Fresh Lime Soda",
              description: "Refreshing lime juice with soda and mint",
              price: 200,
              vegetarian: true
            },
            {
              id: 12,
              name: "Mango Lassi",
              description: "Traditional yogurt-based drink with fresh mango",
              price: 250,
              vegetarian: true
            },
            {
              id: 13,
              name: "Masala Chai",
              description: "Traditional Indian spiced tea",
              price: 150,
              vegetarian: true
            }
          ]
        }
      ]
    }
  },
  {
    id: 4,
    name: "Scenic Farmland",
    description: "Reconnect with nature in our expansive farmland retreat, offering peaceful countryside views, walking trails, and ultimate tranquility.",
    image: "https://images.unsplash.com/photo-1594760910270-8720de623883",
    features: ["Walking trails", "Meditation spots", "Selfie with our Bulls", "Picnic areas", "Relax under the trees"]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: `${publicUrl + "/static/images/resortExterior.jpeg"}`,
    title: "Resort",
    category: "resort"
  },
  {
    id: 2,
    url: `${publicUrl + "/static/images/resortExterior2.jpeg"}`,
    title: "Resort Exterior",
    category: "resort"
  },
  {
    id: 3,
    url: `${publicUrl + "/static/images/resortExterior3.JPG"}`,
    title: "Resort Exterior",
    category: "resort"
  },
  {
    id: 4,
    url: `${publicUrl + "/static/images/resortExterior4.JPG"}`,
    title: "Resort Exterior",
    category: "resort"
  },
  {
    id: 5,
    url: `${publicUrl + "/static/images/room1.jpeg"}`,
    title: "Luxury Suite",
    category: "rooms"
  },
  {
    id: 6,
    url: `${publicUrl + "/static/images/room2.jpeg"}`,
    title: "Luxury Suite",
    category: "rooms"
  },
  {
    id: 7,
    url: `${publicUrl + "/static/images/room3.jpeg"}`,
    title: "Premium Room",
    category: "rooms"
  },
  {
    id: 8,
    url: `${publicUrl + "/static/images/swimmingpool.jpeg"}`,
    title: "Swimming Pool",
    category: "pool"
  },
  {
    id: 9,
    url: `${publicUrl + "/static/images/swimmingpool2.jpeg"}`,
    title: "Swimming Pool",
    category: "pool"
  },
  {
    id: 10,
    url: `${publicUrl + "/static/images/dining.jpg"}`,
    title: "Restaurant Interior",
    category: "dining"
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1594760910270-8720de623883",
    title: "Countryside Views",
    category: "farmland"
  },
  {
    id: 12,
    url: "https://images.unsplash.com/photo-1588152850700-c82ecb8ba9b1",
    title: "Tranquil Farmland",
    category: "farmland"
  },
  {
    id: 13,
    url: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
    title: "Golden Sunset Views",
    category: "farmland"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    rating: 5,
    comment: "An absolutely enchanting experience! The rooms were luxurious, the staff impeccable, and the farmland views simply breathtaking.",
    date: "March 2025"
  },
  {
    id: 2,
    name: "David Chen",
    rating: 5,
    comment: "Perfect getaway from city life. The restaurant's cuisine was exceptional, and the swimming pool at sunset was magical.",
    date: "February 2025"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    rating: 5,
    comment: "Luxtansa exceeded all expectations. The blend of luxury amenities and natural beauty created an unforgettable retreat.",
    date: "January 2025"
  }
];

export const roomTypes = [
  { id: 1, name: "Luxury Room", price: 5000 },
  { id: 2, name: "Premium Room", price: 6000 }
];
